import React, {Fragment} from 'react';
import {Box} from '@mui/material';

import {BeneficiaryCard, ErrorState, MainFooter, StyledGrid} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private/hooks';

import {Loading} from 'presentation/components/Loading/Loading';

import {EmptyTokenState} from './EmptyTokenState';
import {TokenCard} from './TokenCard';
import {useBeneficiaryToken} from '../../hooks/useBeneficiaryToken';

const {loading, pleaseTryAgain, failToLoadTitle} = translations['pt-br'].commons;

export function BeneficiaryToken() {
	const {isMobile} = useMediaQueries();
	const {
		handleFetchToken,
		isEmpty,
		isError,
		isLoading,
		remainingTimeInSeconds,
		tokenNumber,
		handleBack,
	} = useBeneficiaryToken();

	if (isLoading) {
		return <Loading minHeight="100%" text={loading} />;
	}

	if (isError) {
		return (
			<ErrorState
				title={failToLoadTitle}
				description={pleaseTryAgain}
				handleRefresh={handleFetchToken}
			/>
		);
	}

	return (
		<Fragment>
			<StyledGrid.Root p={isMobile ? 2 : 4}>
				<StyledGrid.Item sm={12} md={12} lg={8}>
					{isEmpty ? (
						<EmptyTokenState />
					) : (
						<TokenCard
							tokenNumber={tokenNumber}
							remainingTimeInSeconds={remainingTimeInSeconds}
							handleBack={handleBack}
						/>
					)}
				</StyledGrid.Item>

				<StyledGrid.Item sm={12} md={12} lg={4}>
					<BeneficiaryCard />
				</StyledGrid.Item>
			</StyledGrid.Root>

			<Box mt="auto">
				<MainFooter customMarginBottom={isMobile ? '72px' : undefined} />
			</Box>
		</Fragment>
	);
}
